import { Snackbar, SnackbarOrigin } from '@mui/material';
import React, { useState } from 'react'
import { StyledCopyLink } from './styles';
import { Input } from '../../../ui/Input/Input';
import { IconWrapper } from '../../../ui/IconWrapper/IconWrapper';
import { MdCheck, MdOutlineCopyAll } from 'react-icons/md';
import { IoCheckmark } from 'react-icons/io5';
import { useTranslation } from 'react-i18next';

interface State extends SnackbarOrigin {
  open: boolean;
}

type TProps = {
  className?: string;
}

export const CopyLink: React.FC<TProps> = ({className}) => {
  const [alertState, setAlertState] = React.useState<State>({
    open: false,
    vertical: 'top',
    horizontal: 'center',
  });
  const currentLink = window.location.href;

  const { t } = useTranslation();

  const handleClose = () => {
    setAlertState({ ...alertState, open: false });
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(currentLink);
      setAlertState({ ...alertState, open: true });
    } catch (err) {
      setAlertState({ ...alertState, open: true });
    }
  }

  return (
    <StyledCopyLink className={className}>
      <div className='copy-link'>
        <Input 
          disabled 
          value={currentLink} 
          addon={
            <IconWrapper onClick={copyLink}>
              <MdOutlineCopyAll size={28} />
            </IconWrapper>
          }
        />
        
      </div>
      <Snackbar
        anchorOrigin={{ vertical: alertState.vertical, horizontal: alertState.horizontal }}
        open={alertState.open}
        onClose={handleClose}
        autoHideDuration={2000}
        className='alert'
        message={<div className='alert-text'>
          <IoCheckmark />
          {' '}{t("utils.copied")}
        </div>
      }
        key={alertState.vertical + alertState.horizontal}
      />
    </StyledCopyLink>

  )
}
